<template>
  <div class="navbar-search form-inline mr-sm-3 mt-2">
    <b-form-select @change="changeLanguage($event)" v-model="selectedLanguage">
      <option value="es">Español</option>
      <option value="en">English</option>
    </b-form-select>
  </div>
</template>

<script>
import translator from '@/util/language.js';
import utilsService from '../api/utilsService.vue';
export default {
  data() {
    return {
      selectedLanguage: translator.getLanguage()
    };
  },
  methods: {
    async changeLanguage(value) {
      Swal.fire({
        html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">Cambiando...</h3>
                        </div>
                    </div>`,
        showConfirmButton: false,
        allowOutsideClick: false
      });
      const language = value;
      translator.setLanguage(language);
      this.selectedLanguage = language;
      await utilsService.refreshLanguage();
      window.location.reload();
    }
  }
};
</script>

<style scoped>
select {
  margin-bottom: 10px;
}
</style>
